import {CircularProgress} from "@mui/material";

const CircularLoading = () => <CircularProgress color="secondary" sx={{ ml: 1 }} size={20} />;

export default CircularLoading;